import * as React from "react";

import { cn } from "@/shared/utils/utils";
import { Skeleton } from "./skeleton";

export const CustomSwitchSkeleton = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>): React.ReactElement => (
  <div
    aria-busy="true"
    aria-label="Loading switch"
    data-slot="custom-switch-skeleton"
    className={cn(
      "switch-wrapper flex flex-none flex-row-reverse items-center gap-2",
      className,
    )}
    {...props}
  >
    <Skeleton className="h-4 w-24" />
    <Skeleton className="h-6 w-11 rounded-full" />
  </div>
);
